const Spinner = () => {
  return <span>Loading...</span>;
};

export default Spinner;
